<template>
  <div>
    <div class="mb-6">
      <h2 class="text-lg font-semibold">
        {{ t("settings.mcpServers.title") }}
      </h2>
      <p class="text-muted-foreground text-sm">
        {{ t("settings.mcpServers.description") }}
      </p>
    </div>

    <div class="space-y-4">
      <!-- Create MCP Server Button -->
      <div class="flex justify-start">
        <McpServersCreateDialog>
          <Button variant="outline">
            <Plus class="h-4 w-4 mr-2" />
            {{ t("settings.mcpServers.create") }}
          </Button>
        </McpServersCreateDialog>
      </div>

      <!-- MCP Servers List -->
      <div v-if="status === 'pending'" class="flex justify-center py-8">
        <div class="text-muted-foreground">{{ t("common.loading") }}</div>
      </div>

      <div v-else-if="status === 'error'" class="text-center py-8">
        <p class="text-destructive">{{ t("settings.mcpServers.loadError") }}</p>
      </div>

      <div v-else>
        <McpServersList :mcp-servers="mcpServers" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Plus } from "lucide-vue-next";
import { useApiMcpServers } from "~/composables/api";

const { t } = useI18n();
const { data, status } = await useApiMcpServers();

const mcpServers = computed(() => data.value ?? []);
</script>
